/*
 * TestResults Messages
 *
 * This contains all the text for the TestResults container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.TestResults';

export default defineMessages({
  header: {
    id: `${scope}.header`,
    defaultMessage: 'This is the TestResults container!',
  },
  member: {
    id: `${scope}.member`,
    defaultMessage: 'Member',
  },
  exercise: {
    id: `${scope}.exercise`,
    defaultMessage: 'Test Group',
  },
  sendToSpreadSheet: {
    id: `${scope}.sendToSpreadSheet`,
    defaultMessage: 'Send spreadsheet of selected',
  },
  definition: {
    id: `${scope}.definition`,
    defaultMessage: 'Test',
  },
  results: {
    id: `${scope}.results`,
    defaultMessage: 'Results',
  },
  time: {
    id: `${scope}.time`,
    defaultMessage: 'Time',
  },
  date: {
    id: `${scope}.date`,
    defaultMessage: 'Date',
  },
  technology: {
    id: `${scope}.technology`,
    defaultMessage: 'Technology',
  },
  location: {
    id: `${scope}.location`,
    defaultMessage: 'Location',
  },
  additionalInfo: {
    id: `${scope}.additionalInfo`,
    defaultMessage: 'Additional Info',
  },
  side: {
    id: `${scope}.side`,
    defaultMessage: 'Side',
  },
  pid: {
    id: `${scope}.pid`,
    defaultMessage: 'PID',
  },
  fid: {
    id: `${scope}.fid`,
    defaultMessage: 'FID',
  },
  gender: {
    id: `${scope}.gender`,
    defaultMessage: 'Gender',
  },
  male: {
    id: `${scope}.male`,
    defaultMessage: 'Male',
  },
  female: {
    id: `${scope}.female`,
    defaultMessage: 'Female',
  },
  bodyWeight: {
    id: `${scope}.bodyWeight`,
    defaultMessage: 'Body Weight',
  },
  age: {
    id: `${scope}.age`,
    defaultMessage: 'Age',
  },
  rowProperties: {
    id: `${scope}.rowProperties`,
    defaultMessage: 'Row properties',
  },
  analysisProperties: {
    id: `${scope}.analysisProperties`,
    defaultMessage: 'Analysis properties',
  },
  summaryProperties: {
    id: `${scope}.summaryProperties`,
    defaultMessage: 'Summary properties',
  },
});
